import { escapeRegExpString } from 'ember-super-prosemirror/utils/reg-exp';
import { determineValidChars, DocFormatEnum, getDocFormat } from '../utils';
import { InlineParser } from './inline';
import { MarkdownParser } from './markdown';
function getVariable(state, chars, regex) {
  // Find the variable in the text
  const matches = state.src.slice(state.pos).match(regex);
  if (!matches) return false;
  const full = matches[0];
  const prefix = matches[1];
  const name = matches[2];

  // Check if first character is the variable and if not, move on
  if (matches.index !== 0) {
    return false;
  }
  if (!name) {
    return false;
  }
  let isStrong = false;
  if (chars.strong && prefix === `${chars.strong.first}${chars.strong.second}`) {
    isStrong = true;
  }
  const endPosition = state.pos + full.length;
  return {
    name,
    endPosition,
    isStrong
  };
}
function generateRegex(variables, chars) {
  const prefixes = [`${chars.normal.first}${chars.normal.second}`];
  const suffixes = [`${chars.normal.last}`];
  if (chars.strong) prefixes.push(`${chars.strong.first}${chars.strong.second}`);
  if (chars.strong) suffixes.push(`${chars.strong.last}`);
  const prefix = prefixes.join('|');
  const suffix = suffixes.join('|');
  return new RegExp(`(${prefix})(${variables.join('|')})(${suffix})`);
}

// Goes through each section in the passed in text and if a character
// matches one of the special variable characters, we create a markdown-it token
// which then the MarkdownParser will translate to a node to display in the editor
export function createInlineVariableRule(schema, variables) {
  const chars = determineValidChars(schema);
  const validNodes = Object.keys(schema.nodes);

  // NOTE we need to escape the variable strings to prevent errors with generating the reg exp
  const escapedVariables = variables.map(v => escapeRegExpString(v));
  variables = [...escapedVariables, `[^${chars.normal.first}${chars.strong?.first ? chars.strong.first : ''}]+?`]; // catch all, for invalid variables

  return function (state) {
    const variable = getVariable(state, chars, generateRegex(variables, chars));
    if (!variable) return false;
    let {
      name
    } = variable;
    const {
      isStrong,
      endPosition
    } = variable;
    if (!validNodes.includes(name)) {
      name = 'invalidVariable';
    }
    if (isStrong) {
      state.push('strong_open');
    }
    state.push(name, 'span', 0);
    if (isStrong) {
      state.push('strong_close');
    }
    state.pos = endPosition;
    return true;
  };
}
const ParserEnum = {
  Inline: InlineParser,
  Markdown: MarkdownParser
};
const docFormatToParserMapping = {
  [DocFormatEnum.Markdown]: ParserEnum.Markdown,
  [DocFormatEnum.MailerV2]: ParserEnum.Markdown,
  [DocFormatEnum.Nda]: ParserEnum.Markdown,
  [DocFormatEnum.Notification]: ParserEnum.Inline
};
export function determineParser(schema) {
  const format = getDocFormat(schema);
  return docFormatToParserMapping[format];
}